import type { CSSProperties, ReactNode } from "react";

import { useSkipEntranceOnMount } from "./skip-entrance-context";
import styles from "./stagger-item.module.css";

export type StaggerItemProps = {
  /** Position in the sequence; each step delays the entrance by 100ms, capped at index 6. */
  index: number;
  /** `card` fades, rises and scales in; `fade` only fades in. */
  variant?: "card" | "fade";
  children: ReactNode;
};

/** Entrance animation for items that mount in sequence. It never animates size, so nothing around it moves. */
export const StaggerItem = ({ index, variant = "card", children }: StaggerItemProps) => {
  const skip = useSkipEntranceOnMount();

  return (
    <div
      className={`${styles.item} ${styles[variant]} ${skip ? styles.skip : ""}`}
      style={{ "--stagger-index": index } as CSSProperties}
    >
      {children}
    </div>
  );
};
